import { useEffect, useState } from 'react';
import { Box, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useParams } from "react-router-dom";
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import classService from '../../services/class_service';
import axios from "axios";



function UpdateKelas() {
  const { id } = useParams();
  const [values, setValues] = useState({
    id:id,
    // datetime_start: '',
    // datetime_end: '',
    // room: '',
    name: '',
    description: '',
    location: '',
    calories: '',
    capacity: ''
  })
  useEffect(()=> {
    axios.get('https://ikigai-server.herokuapp.com/api/v1/classes/'+id)
    .then(res => {
      setValues({...values, 
        name:res.data.name, 
        // datetime_start:res.data.datetime_start, 
        // datetime_end:res.data.datetime_end,
        // room:res.data.room, 
        description: res.data.description, 
        location: res.data.location, 
        calories: res.data.calories, 
        capacity: res.data.capacity})
    }).catch(err => console.log(err))
  }, [])


  const handleCancel = () => {
    navigate(-1);
  };

  // Handle for submission
  const handleSubmit = (e) => {
    e.preventDefault();
    axios.patch('https://ikigai-server.herokuapp.com/api/v1/classes/'+id, values)
    .then(res => {
      navigate('/dashboard/management/kelas')
    }).catch(err => console.log(err))
  };

  // const handleSubmit = async (id, values) => {
  //   try {
  //     const response = await classService.updateOneClass(id, values);
  //     console.log(response);
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }
  
  const navigate = useNavigate();

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Kelas" />
      </Box>

      <Box sx={{ marginLeft:'280px', marginRight:'50px', p: 2 }}>
        <form onSubmit={handleSubmit}>

          {/* Input Nama */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Nama"
              value={values.name}
              onChange={e => setValues({...values, name: e.target.value})}
              variant="outlined" />
          </Box>

          {/* Input Lokasi */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <FormControl fullWidth variant="outlined">
              <InputLabel id="location-select-label">Lokasi</InputLabel>
              <Select
                labelId="location-select-label"
                id="location-select"
                value={values.location}
                label="lokasi"
                onChange={e => setValues({...values, location: e.target.value})}
              >
                <MenuItem value={'dmall'}>Dmall</MenuItem>
                <MenuItem value={'kartini'}>Kartini</MenuItem>
                <MenuItem value={'ekalos'}>Ekalos</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Input Jenis Kelas
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <FormControl fullWidth variant="outlined">
              <InputLabel id="jeniskelas-select-label">Jenis Kelas</InputLabel>
              <Select
                labelId="jeniskelas-select-label"
                id="jeniskelas-select"
                value={jenis_kelas}
                onChange={handleJenisKelasChange}
                label="jenis_kelas"
              >
                <MenuItem value={'weight_loss'}>Weight Loss</MenuItem>
                <MenuItem value={'lean_tone'}>Lean Tone</MenuItem>
                <MenuItem value={'gain'}>Gain</MenuItem>
                <MenuItem value={'mental_health'}>Mental Health</MenuItem>
              </Select>
            </FormControl>
          </Box> */}

          {/* Input Slot */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Slot"
              type="number"
              value={values.capacity}
              onChange={e => setValues({...values, capacity: e.target.value})}
              variant="outlined" />
          </Box>

          {/* Input Kapasitas
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Kapasitas"
              type="number"
              value={kapasitas}
              onChange={handleKapasitasChange}
              variant="outlined" />
          </Box> */}

          {/* Input Kalori */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Kalori"
              value={values.calories}
              onChange={e => setValues({...values, calories: e.target.value})}
              variant="outlined" />
          </Box>

          {/* Input Tanggal
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label=""
              type="date"
              value={valuestanggal}
              onChange={handleTanggalChange}
              variant="outlined" />
          </Box> */}

          {/* Pilih Jam
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <TextField
              required
              fullWidth
              label="Jam Mulai"
              type="time"
              value={jam_mulai}
              onChange={handleJamMulaiChange}
              variant="outlined" />
          </Box> */}
          {/* <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <TextField
              required
              fullWidth
              label="Jam Berakhir"
              type="time"
              value={jam_akhir}
              onChange={handleJamAkhirChange}
              variant="outlined" />
          </Box> */}

          {/* Input Desc */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Deskripsi"
              value={values.description}
              onChange={e => setValues({...values, description: e.target.value})}
              variant="outlined" />
          </Box>

          <Button type="submit" variant="contained" sx={{ boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white' }}>Save</Button>
          <Button variant="contained" sx={{ left:10 , boxShadow: 5, textTransform: 'none', bgcolor: '#FF5630', color: 'white' }}onClick={handleCancel}>Cancel</Button>
        </form>
      </Box></>
  );
}

export default UpdateKelas;